
<template>
    <div class="about">
      <mobileHeader></mobileHeader>
      <div class="page-2">
        <div class="page2Warp flexB h100">
          <div class="zwHeader w100"></div>
          <div class="content flex1 w100">
            <div class="info">
              <div class="title fAb flexSw">
                <div>About Us</div>
                <mobileBak :home-index="1"></mobileBak>
              </div>
              <div class="desc fOM">
                <div class="descText" v-html="aboutInfo.one.desc">
                </div>
                <div class="descList">
                  <div class="descListItem" v-for="v in aboutInfo.two">
                    <img class="artItemImage" src="../../assets/image/art_list_log.png" alt="">
                    <div class="descListItemText fOR" v-html="v.desc">
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
</template>
<script>
import mobileHeader from "@/components/Common/MobileHeader.vue";
import mobileBak from "@/components/Common/mobileBak.vue";

export default {
  components: {mobileHeader,mobileBak},
  props:{
    aList:{
      type:Array,
      default(){
        return []
      }
    }
  },
  computed:{
    aboutInfo(){
      return this.$store.getters.homeData.aboutInfo
    }
  }
}
</script>

<style scoped lang="scss">
.about{
  height: 100%;
}
.page-2{
  height: 100%;
  background-image: url("../../assets/image/mobile/m_bg_2.png");
  background-size: 100% 100%;
  background-repeat: no-repeat;
  .page2Warp{
    .content{
      display: flex;
      align-items: center;
      flex-direction: column;
      justify-content: flex-start;
      padding: 0 .5rem 0 1.3rem;
      box-sizing: border-box;
      color: #fff;
      flex: 1;
      overflow: hidden;
      .info{
        padding: 1.5rem 0 0;
        display: flex;
        width: 100%;
        box-sizing: border-box;
        //align-items: center;
        flex-direction: column;
        overflow: hidden;
        .title{
          font-size: 1.5rem;
          padding-right: .8rem;
        }
        .desc{
          flex: 1;
          overflow: hidden;
          overflow-y: auto;
          margin-top: .8rem;
          .descText{
            font-size: .9rem;
            line-height: 1.4rem;
          }
          .descList{
            padding-bottom: 1rem;
            .descListItem{
              margin-top: 1rem;
              position: relative;
              padding-left: 1rem;
              .descListItemText{
                border-radius: 2.5rem;
                background: linear-gradient(146deg, #3578C1 0%, rgba(43,106,185,0) 80%);
                color: #fff;
                font-size: .8rem;
                padding: .5rem .5rem .5rem 2.3rem;
                word-wrap: break-word;
              }
              .artItemImage{
                width: 3rem;
                position: absolute;
                left: 0;
                top: -.4rem;
                z-index: 10;
              }
            }
          }
        }
      }
    }
  }
}
.zwHeader{
  height: 4rem;
}
</style>
